import { REQUIRES_MARKING_FILTER_ID, REQUIRES_MARKING_FILTER_TITLE } from '../../constants';
import { createCheckboxFilter } from './createCheckboxFilter';

export const createRequiresMarkingFilter = () =>
    createCheckboxFilter({
        id: REQUIRES_MARKING_FILTER_ID,
        title: REQUIRES_MARKING_FILTER_TITLE,
    });
